
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class TabelOrderSet extends Vue {
  @Prop({ default: () => [], type: Array })
  listData: any;
  @Prop({ default: 1, type: Number })
  index: number;
  @Prop({ default: 1, type: Number })
  pageNum: number;
  @Prop({ default: false, type: Boolean })
  disabled: boolean;
  handleOrderChange(type) {
    if (this.disabled) return;
    this.$emit("orderChange", type);
  }
}
